<template>
  <span class="highlighted-text"
    ><template v-for="(segment, index) in segments" :key="index"
      ><mark v-if="segment.match">{{ segment.text }}</mark
      ><template v-else>{{ segment.text }}</template></template
    ></span
  >
</template>
<script setup lang="ts">
import { computed } from "vue";
import { highlightSegments } from "./tradeChatLogsPresenters";

/** Renders text with the search terms marked, without ever interpreting it as HTML. */
const props = defineProps<{ text: string; terms: string[] }>();

const segments = computed(() => highlightSegments(props.text, props.terms));
</script>
<style scoped lang="scss">
.highlighted-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
mark {
  padding: 0 0.1em;
  border-radius: 2px;
  background: var(--phoenix-warning-bg-subtle);
  color: inherit;
}
</style>
